import styled from 'styled-components';
import { FIAT_BACKGROUND, BLOCKCHAIN_BACKGROUND } from '../../config/media';

export const CreateAssetModalWrapper = styled.div`
    
    .btn-wrapper {
        display: flex;
        justify-content: space-between;
        margin-top: 2rem;
        .ant-btn {
            width: 45%;
        }
    }
`
export const CreateAssetContainer = styled.div`
    padding: 1.5rem 1rem;
    font-family: NHaasGroteskTXPro, system-ui;

    .ant-input {
        border: 1px solid #707070 !important;
    }
    .coin-ico, .sub-text {
        color: #ffffff;
    }
    .first-title,
    .title {
        font-family: HaasGrotDisp;
        font-size: 24px;
        font-weight: bold;
    }
    .first-title {
        font-size: 28px;
        margin: 0.5rem 0rem;
        color: #ffffff; 
    }
    .sub-title {
        font-family: HaasGrotDisp;
        font-size: 15px;
        font-weight: bold;
        /* margin-top: 5px; */
    }
    .description {
        color: #A8A8B1;
        font-size: 12px;
    }
    .d-flex {
        display: flex;
    }
    .align-items-center {
        align-items: center;
    }
    .ant-radio-wrapper-checked {
        color: #000000;
        font-weight: bold;
    }
    .existing-coin {
        padding-left: 2rem; 
    }
    .asset-coin {
        border: 1px solid #707070;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.5rem 0.75rem;
        .anticon {
            color: #42454D;
        }
    }
    .coin-icon {
        margin-right: 5px;
        width: 1.5rem;
    }
    .asset-coin-details {
        display: flex;
        padding: 1rem 0rem;
        .coin-wrapper {
            margin-right: 1rem;
            .coin-ico {
                background: transparent;
                p {
                    color: #A8A8B1;
                }
            }
        }
        .content-description {
            font-size: 12px;
            width: 15rem;
        }
        .provider-content {
            margin-top: 0.5rem;
        }
        .provider-text {
            font-size: 11px;
        }
    }
    .link {
        // color: #0000FF;
        cursor: pointer;
        font-size: 12px;
        margin: 0px 5px;
    }
    .step-3-dash-link {
        color: #fff;
        margin-bottom: 8%;
        margin-left: 1%;
    }
    .btn-wrapper {
        display: flex;
        margin-top: 1rem;
        .ant-btn {
            flex: 1
        }
        .separator {
            margin: 5px;
        }
        .ant-btn-primary {
            color: #fff;
            background-color: #3A4FFF;
            border-color: #3A4FFF;
        }
        .ant-btn-primary:disabled {
            color: #fff;
            background-color: #42454D;
            border-color: #42454D;
        }
    }
    .coin-option-wrapper {
        border: 1px solid #707070;
        border-radius: 4px;
        margin-top: 0.5rem;
        max-height: 18rem;
        overflow-y: auto;
        color: #A8A8B1;
        .coin-option {
            padding: 1rem;
        }
        &:hover {
            border-color: #3A4FFF;
        }
        .coin-option:hover {
            background-color: #3A4FFF;
            color: #ffffff;
            cursor: pointer;
        }
    }
    .create-new-link {
        color: #A8A8B1;
        text-align: center;
        margin-top: 1rem;
        .btn-content {
            margin-top: 1rem;
            margin-bottom: 0.5rem;
            color: #fff;
            background-color: #3A4FFF;
            border-color: #3A4FFF;
            width: 100%;
        }
    }
    .grey-warning {
        background-color: #545454;
        color: #ffffff;
        display: flex;
        padding: 1rem 2rem 1rem 1rem;
        margin-top: 2rem;

        .warning-text {
            font-size: 45px;
            padding: 0rem 2rem 0rem 1rem;
        }
        .icon-wrapper {
            margin-right: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .image-crypto-fiat {
            .fiat-icon {
                width: 5rem; 
            }
        }
        .fiat-icon {
            width: 4rem;
        }
        .sub-title {
            color: #ffffff;
        }
    }
    .red-warning {
        background-color: #460000;
        color: #ffffff;
        display: flex;
        padding: 1rem 2rem 1rem 1rem;
        margin-top: 2rem;
        .icon-wrapper {
            margin-right: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .image-crypto-fiat {
            .fiat-icon {
                width: 5rem; 
            }
        } 
        .link-content {
            color: #3A4FFF;
            cursor: pointer;
        }
    }
    .preview-coin-container {
        display: flex;
        margin: 2rem 0rem;

        .preview-content {
            flex: 1;
            align-items: center;
            justify-content: center;
            display: flex;

            .preview-color-tip {
                position: relative;
                right: 35px;

                .line {
                    position: absolute;
                    border-top: 1px solid #fff;
                    width: 35px;
                    top: 12px;
                    margin-left: 3px;
                }
            }
            .preview-symbol-tip {
                position: relative;
                left: 35px;
                bottom: 22px;

                .line {
                    position: absolute;
                    border-top: 1px solid #fff;
                    width: 50px;
                    top: 10px;
                    right: 50px;
                    margin-right: 3px;
                }
            }
            .preview-name-tip {
                position: relative;
                top: 8px;
                right: 8px;

                .line {
                    position: absolute;
                    border-top: 1px solid #fff;
                    width: 60px;
                    top: 10px;
                    right: 40px;
                    margin-right: 3px;
                }
            }
            .preview-icon-tip {
                position: relative;
                left: 30px;

                .line {
                    position: absolute;
                    border-top: 1px solid #fff;
                    width: 35px;
                    top: 10px;
                    right: 30px;
                    margin-right: 3px;
                }
            }
            .coin-ico {
                background: transparent;
                color: #ffffff;
            }
        }
        .icon-preview {
            height: 94px;
            width: 94px;
        }
        .left-content {
            display: flex;
            min-height: 10rem;
            justify-content: center;
            padding: 1rem 0rem;
            width: 10rem;

            .no-icon {
                .coin-ico {
                    align-items: center;
                    display: flex;
                    font-size: 25px !important;
                    justify-content: center;
                    background: #29292C;
                    border: 1.5px solid #ffffff;
                    color: #ffffff;
                }
            }
        }
        .blockchain {
            background-image: url(${BLOCKCHAIN_BACKGROUND});
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }
        .fiat {
            background-image: url(${FIAT_BACKGROUND});
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }
        .right-content {
            border-left: 1px solid #A8A8B1;
            margin-left: 1rem;
            min-height: 10rem;
            padding: 1rem 0rem 0rem 1rem;
            flex: 1;
            // width: 65%;
            .ant-radio {
                opacity: 0.5;
            }
            .ant-radio .ant-radio-checked {
                opacity: 1 !important;
            }
            .ant-radio-group{
                .ant-radio-wrapper {
                    span {
                        color: #ffffff;
                        font-weight: 100;
                        /* opacity: 0.5; */
                    }
                }
                .ant-radio-wrapper .checked {
                    .ant-radio {
                        opacity: 1;
                        }
                    }
            }
            .ant-select {
                width: 100%;
            }
        }
        .new-asset-icon {
            width: 3rem;
        }
        .ant-input-group-addon {
                        .ant-btn-primary {
                        color: #fff;
                        background-color: #3A4FFF;
                        border-color: #3A4FFF;
                        }
                        }
    }
    .preview-detail-container {
        border-top: 1px solid #A1A1A1;
        color: #ffffff;
        padding: 1rem;
        width: 65%;
    }
    .fiat-confirm-content {
        width: 75%;
        color: #A8A8B1;
    }
    .section-wrapper {
        border-bottom: 1px solid #A8A8B1;
        padding-bottom: 1.5rem;
        margin: 0.5rem 1rem 0.5rem 1rem;

        .color-wrapper {
            padding-top: 1rem;
            display: flex;
            // align-items: center;

            .coin-wrap {
                margin-right: 1rem;
                .coin-ico {
                    border: 1.5px solid #ffffff !important;
                    background: transparent;
                }
            }
            .picker-wrapper,
            .ant-input {
                width: 100%;
            }
            .md-field-wrap {
                padding-top: 0px;
            }
        }
        .sub-txt {
            color : #A8A8B1 ;
         }
        .about-wrapper {
            .ant-input {
                width: 100%;
            }
        }
        .field-description {
            color: #ffffff;
            font-size: 12px;
        }
        .preview-icon {
            height: 94px;
            margin-right: 8px;
            width: 94px;
            color:white;
        }
        .ant-input-number{
            background-color: transparent;
            color: #ffffff;
            .ant-input-number-handler-wrap {
                background-color : transparent;
                color: #ffffff;
                .anticon {
                    color: white;
                }
            }
        }
    }
    .last {
        border-bottom: 0px !important;
    }
    .md-field-wrap-search {
        padding-top: 1rem;
        .ant-input-wrapper {
            width: 300px;
        }
    }
    .md-field-wrap {
        padding-top: 1rem;

        .ant-upload,
        .ant-input-number,
        .ant-input {
            width: 100%;
            .ant-btn {
                text-align: left;
                width: 100%;
            }
        }
        .file-container {
            border: 1px solid #b9b9b9;
            border-radius: 4px;
            display: block;
            padding: 0.25rem;
            white-space: nowrap;
            position: relative;
            width: 300px;

            label {
                display: block;
                padding-bottom: 0;
                box-sizing: border-box;
            }
            .ant-form-item-control {
                line-height: 1;
                .ant-form-item-children{
                    .ant-input-group-addon {
                        .ant-btn-primary {
                        color: #fff;
                        background-color: #3A4FFF;
                        border-color: #3A4FFF;
                        }
                        }
                }
            }
            input {
                opacity: 0;
                position: fixed;
                left: -999px;
            }
        }
        .icon-upload {
            .file-container {
                color: #A8A8B1;
                border: 0px;
                width: 105px;

                label {
                    cursor: pointer;
                }
            }
        }
    }
    .edit-wrap {
        padding: 1rem;
        .md-field-wrap {
            .picker-wrapper {
                width: 250px;
            }
            .ant-select {
                width: 100%;
            }
        }
    }
    .burn-content {
        margin-left: 1rem;
        .md-field-wrap {
            padding-top: 0px;
        }
    }
    .assets-wrapper {
        @media (max-width: 1200px) {
            margin: 0rem;
            width: 100%;
        }
        margin: 1rem;
        // width: 25rem;
        .field-description {
            color: #A8A8B1;
        }
        .field-wrap {
            border-bottom: 1px solid #A9A9A9; 
            padding: 1.25rem 0.25rem;
            
            .ant-checkbox-wrapper {
                display: flex;
                .ant-checkbox {
                    margin-top: 10px;
                    height:fit-content;
                }

                .ant-checkbox-checked::after {
                    border: none;
                }

                .ant-checkbox:hover {
                    margin-top:10px;
                }
            }
            .ant-input-number {
                width: 100%;
            }
            .description {
                color: #A8A8B1;
                font-size: 12px;
            }
        }
        .general-wrapper {
            display: flex;
            justify-content: space-between;
        }
    }
    .coin-limit-wrap {
        .field-wrap {
            padding: 1.5rem;
            border-bottom: 1px solid #A9A9A9; 
        }
        .last .ant-input-number {
            width: 100%;
        }
        .btn-wrapper {
            .ant-btn:first-child {
                margin-right: 2rem;
            }
        }
        .next-btn {
            .ant-btn {
                width: 100%;
            }
        }
    }
    .burn-wrapper {
        .type_wrapper {
            h3 {
                font-weight: bold;
                margin-bottom: 0;
            }
        }
        .ant-btn,
        .ant-input-number {
            width: 100%;
        }
    }
    .add-asset-wrapper {
        .tab-wrapper {
            padding: 0;
            width: 100%;
            border-top: 1px solid #707070;
            margin-top: 8px;
        }
        .ant-tabs-tab {
            flex: 1;
            text-align: center;
            border-top: 6px solid transparent;

            .tab-description {
                font-size: 11px;
                color: #7F7F7F;
                font-weight: normal;
            }
        }
        .ant-tabs-tab-active {
            border-top: 6px solid #ffffff;
        }
    }
    .anchor {
        color: #3A4FFF;
        text-decoration: underline;
        cursor: pointer;
        margin-right: 1%;
    }
    .steps-dash-link {
        color: #fff;
    }
    .footer {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 35px;
    }
    @media (max-width: 960px) {
        padding: 1.5rem 0;
        .flex-column {
            flex-direction: column;
        }
        .ant-radio-group {
            width: 100%;
        }
        .section-wrapper {
            .align-items-center,
            .color-wrapper {
                flex-direction: column;
                align-items: flex-start;
            }
            .preview-icon {
                height: 100%;
            }
        }
        .md-field-wrap {
            width: 100%;
            .ant-upload,
            .ant-input-number,
            .ant-input {
                width: 100%;
            }
            .file-container {
                width: 100%
            }
        }
        .preview-coin-container {
            .preview-content-align {
                margin: 0 0 20px 20px;
            }
            .left-content {
                /* background: transparent; */
                border: 1.5px solid #ffffff;
                color: #ffffff;
                width: 7rem;
            }
            .no-icon {
                .coin-ico {
                    width: 25px;
                    height: 25px;
                    margin-top: 2rem;
                }
            }
        }
        .md-field-wrap-search {
            .ant-input-wrapper {
                width: 100%;
            }
        }
        .preview-detail-container {
            width: 100%;
        }
    }
    @media (max-width:280px) {
        .edit-wrap {
             .md-field-wrap {
                 .picker-wrapper {
                    width: 150px;
                }
            }
        }
    }
    @media (max-width:425px) {
        .add-asset-wrapper {
            .tab-wrapper {
                .ant-tabs-nav .ant-tabs-tab {
                margin: 0;
                padding: 6px 5px;
                font-size: 14px;
                }
            }
        }
    }
`;
